import storageService, { StorageServiceInterface, StorageType } from 'src/services/storage-service';
import { CMSFeatureTestConfig } from 'src/shared/types';

export enum StorageKeys {
    FEATURE_TEST_CONFIG = 'features.featureTestConfig',
    ANNOUNCEMENTS_MODAL_SHOWN = 'global.announcements_modal_shown',
}

const localStorageOptions = {
    storage: StorageType.LOCAL_STORAGE,
};

export class GlobalStorageService {
    private storageService: StorageServiceInterface;

    public constructor(storageService: StorageServiceInterface) {
        this.storageService = storageService;
    }

    public getFeatureTestConfig(): CMSFeatureTestConfig {
        return this.storageService.get(StorageKeys.FEATURE_TEST_CONFIG, localStorageOptions);
    }

    public setFeatureTestConfig(featureTestConfig: CMSFeatureTestConfig): void {
        this.storageService.remove(StorageKeys.FEATURE_TEST_CONFIG);
        this.storageService.save(StorageKeys.FEATURE_TEST_CONFIG, featureTestConfig, localStorageOptions);
    }

    /**
     * Get whether the announcements modal has been shown to the user
     * @returns boolean - true if modal has been shown, false otherwise
     */
    public getAnnouncementsModalShown(): boolean {
        return this.storageService.get(StorageKeys.ANNOUNCEMENTS_MODAL_SHOWN, localStorageOptions) || false;
    }

    /**
     * Set whether the announcements modal has been shown to the user
     * @param shown - boolean indicating if modal has been shown
     */
    public setAnnouncementsModalShown(shown: boolean): void {
        this.storageService.save(StorageKeys.ANNOUNCEMENTS_MODAL_SHOWN, shown, localStorageOptions);
    }

    public clearAll(): void {
        this.storageService.remove(StorageKeys.FEATURE_TEST_CONFIG, localStorageOptions);
        this.storageService.remove(StorageKeys.ANNOUNCEMENTS_MODAL_SHOWN, localStorageOptions);
    }
}

export default new GlobalStorageService(storageService);
